function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0)
      return c.substring(name.length, c.length);
  }
  return "";
}

function redirectLocale(locale) {
  if (!window.location.href.includes(`https://greenboutiq.com/${locale}`)) {
    var url = window.location.href;


    var txt2 = url.slice(0, 24) + `${locale}/` + url.slice(24);
    window.location.href = txt2;
  }
}

if (getCookie("language") == "") {

  $.getJSON('https://ipapi.co/json/', function (data) {
    if (data.country_code == 'DE') {
      document.cookie = "language=DE;";
      redirectLocale('de')
    }
  });

}

if (getCookie("language") == 'DE') {

  redirectLocale('de');

}

document.querySelectorAll('.product__add-button').forEach(product => {
  product.addEventListener('click', () => {
    triggerRelatedProductsDialog(product.dataset.productId)
  })
})

/**
 * Related products dialog
 */
async function triggerRelatedProductsDialog(productId) {
  if (!productId) {
    const res = await fetch('/cart.js')
    const data = await res.json()

    if (data.items[0]) {
      productId = data.items[0].product_id
    } else {
      console.error('[triggerRelatedProductsDialog]: Cart was done fetching before product was added')
      return
    }
  }

  const resRelated = await fetch(`/recommendations/products.json?product_id=${productId}&limit=10&intent=related`)
  const dataRelated = await resRelated.json()

  const html = createRelatedCards(dataRelated)
  document.querySelector('.related-products-dialog .related-products-grid').innerHTML = html

  const overlay = document.querySelector('.js-slideout-overlay')
  overlay.style.opacity = '0.8'
  overlay.style.visibility = 'visible'

  const dialog = document.querySelector('.related-products-dialog')
  dialog.style.opacity = '1'
  dialog.style.visibility = 'visible'
}

// Closes the related products dialog when clicked on the close button.
document.querySelector('.related-products-dialog__close').addEventListener('click', () => {
  closeRelatedProductsDialog()
})

// Closes the related products dialog when clicked on the overlay outside dialog content.
document.querySelector('.related-products-dialog').addEventListener('click', (event) => {
  if (event.target === event.currentTarget) {
    closeRelatedProductsDialog()
  }
})

function closeRelatedProductsDialog() {
  const overlay = document.querySelector('.js-slideout-overlay')
  overlay.style.opacity = '0'
  overlay.style.visibility = 'hidden'

  const dialog = document.querySelector('.related-products-dialog')
  dialog.scrollTop = 0
  dialog.style.opacity = '0'
  dialog.style.visibility = 'hidden'
}

/**
 * Creates the related product cards
 */
function createRelatedCards(data) {
  let html = ''
  const formatter = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  })

  const { products } = data
  products.forEach(product => {
    html += `<div class="related-product">
      <a href="${product.url}" title="${product.title}">
      <img src="${product.featured_image}" alt="${product.title}" />
      </a>
      <div class="product-info">
        <p class="product-title">${product.title}</p>
        <p class="price">
          ${formatter.format(product.price / 100)}
        </p>
        <form method="post" action="/cart/add" accept-charset="UTF-8" class="product_form" enctype="multipart/form-data" data-product-form=""
          data-product-id="${product.id}"
        >
          <input type="hidden" name="id" value="${product.id}">
        </form>
      </div>
    </div>`
  })

  return html
}

/** non-shopmonkey custom **/
/** preventDefault for onSubmit for search forms */
function blockSearchPage(mobileOnly = false) {
  console.log('starting attach')
  const handler = (event) => {
    event.preventDefault()
    console.log('clicked')
  }

  const forms = [...document.querySelectorAll('predictive-search form')]

  if (mobileOnly) {
    document.addEventListener('resize', () => {
        for (const form of forms) {
          form.removeEventListener('submit', handler) // prevent event duplication.
          
          if (window.innerWidth <= 980) {
            form.addEventListener('submit', handler)
          }
        }
    })
  } else {
    console.log('attaching')
    for (const form of forms) form.addEventListener('submit', handler)
  }
}
blockSearchPage()